module.exports = __webpack_public_path__ + "img/background_1.f492e2ad.png";